import { inject, Injectable } from '@angular/core';
import { lastValueFrom, timeout, TimeoutError } from 'rxjs';
import { HttpClientService } from './http-client.service';

export interface UserAccessRequest {
  name?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  company?: string | null;
  country?: string | null;
  street?: string | null;
  streetNumber?: string | null;
  city?: string | null;
  zip?: string | null;
  message?: string | null;
  dataConsent?: boolean | null;
}

@Injectable({
  providedIn: 'root',
})
export class UserAccessService {
  private readonly httpClient = inject(HttpClientService);

  public async requestUserAccess(request: UserAccessRequest): Promise<void> {
    try {
      await lastValueFrom(this.httpClient.postRequest('/user/requestUserAccess', request).pipe(timeout(5000)));
    } catch (error) {
      if (error instanceof TimeoutError) {
        throw new Error('Request timeout - server not responding', { cause: error });
      }
      throw error;
    }
  }
}
